import { render, staticRenderFns } from "./ReadPage.vue?vue&type=template&id=3e3582fb&"
import script from "./ReadPage.vue?vue&type=script&lang=ts&"
export * from "./ReadPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports